import {Resort} from '../../resortDetails/resort';

export const resortIdToAbbreviation = (resortId: number, allResorts: Resort[]): string => {
  const resort = allResorts.find(r => r.resortId === resortId);
  return resort ? resort.resortAbbreviation : '';
};

export const resortIdToResortName = (resortId: number, allResorts: Resort[]): string => {
  const resort = allResorts.find(r => r.resortId === resortId);
  return resort ? resort.resortName : '';
};